import { useLocalStorage } from "usehooks-ts";
import { env } from "../../env";

export function useProdMode() {
  const [prodMode] = useLocalStorage("prodMode", false);

  return env.VITE_ENVIRONMENT === "production" || prodMode;
}
